import { useAuth } from "m2m-components/storage/useM2mAuth"
import { useAuthBearerFetch } from "matsuri-hooks"
import { m2mCleaning } from "@/endpoints/m2m-cleaning"

type CompanyNotification =
    | {
          exists: false
      }
    | {
          exists: true
          text: string
      }

export const useCompanyNotification = () => {
    const { token } = useAuth()
    const endpoint = m2mCleaning.cleanerV4.getCompanyNotificationForCleaner

    return useAuthBearerFetch<CompanyNotification>(token, endpoint(), {
        method: endpoint.method
    })
}
